import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import { toRoman } from 'helpers'
import { getMinutesFormat } from 'helpers/datetime'

import { Option } from '../../components'
import { STATIC_TOOLTIPS_ID } from '../../constants.jsx'

import styles from './Options.scss'


const Options = (props) => {

    const vehicleLevels = () => {
        const min = props.battleRegulations.min_vehicle_level
        const max = props.battleRegulations.max_vehicle_level

        return min === max ? toRoman(max) : `${toRoman(min)}-${toRoman(max)}`
    }

    const playersNumber = () => {
        const min = props.battleRegulations.min_players_number
        const max = props.battleRegulations.max_players_number

        return min === max ? max : `${min}-${max}`
    }

    const battleDuration = getMinutesFormat(props.battleRegulations.battle_duration / 60)

    const className = classNames(styles.base, {
        [styles.base__viewInline]: props.inline,
    })

    const battleDurationTooltipId = props.inline ?
        STATIC_TOOLTIPS_ID.fort_battle_duration :
        STATIC_TOOLTIPS_ID.sortie_duration

    return (
        <div className={className}>
            <div className={styles.item}>
                <Option
                    type={Option.TYPES.level}
                    value={vehicleLevels()}
                    tooltipId={STATIC_TOOLTIPS_ID.vehicle_levels}
                />
            </div>
            <div className={styles.item}>
                <Option
                    type={Option.TYPES.players}
                    value={playersNumber()}
                    tooltipId={STATIC_TOOLTIPS_ID.players_count}
                />
            </div>
            <div className={styles.item}>
                <Option
                    type={Option.TYPES.duration}
                    value={battleDuration}
                    tooltipId={battleDurationTooltipId}
                />
            </div>
            <div className={styles.item}>
                <Option
                    type={Option.TYPES.legionaries}
                    value={props.battleRegulations.max_legionaries_number}
                    tooltipId={STATIC_TOOLTIPS_ID.legionaries_count}
                />
            </div>
        </div>
    )
}

Options.propTypes = {
    battleRegulations: PropTypes.object.isRequired,
    inline: PropTypes.bool,
}

export default Options



// WEBPACK FOOTER //
// ./components/BattleWizard/components/Options/Options.jsx